function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function capitalize(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
function fromCamelToSentence(camelCaseString) {
  return capitalize(camelCaseString.split(/(?=[A-Z])/).join(' '));
}

var extractMetadata = function extractMetadata() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var extraction = {};
  Object.keys(props).forEach(function (key) {
    if (!props[key]) {
      return;
    }
    var propType = props[key].type ? props[key].type : props[key];
    var label = props[key].label === undefined ? fromCamelToSentence(key) : props[key].label;
    extraction[key] = _objectSpread2(_objectSpread2({}, propType._meta), {}, {
      label: label,
      propName: key,
      isCollapsible: props[key].isCollapsible,
      isPrivate: props[key].isPrivate,
      max: props[key].max,
      min: props[key].min,
      tooltip: props[key].tooltip
    });
  });
  return extraction;
};

var PropTypes = {};
function getShim() {
  function shim() {}
  function requiredShim() {}
  shim.isRequired = requiredShim;
  return shim;
}
var classicPropTypes = ['array', 'bool', 'string', 'color', 'number', 'icon', 'image', 'slider', 'media', 'product', 'category', 'sectionHeader', 'subHeader', 'editorFull', 'editorMinimal', 'readOnly', 'date', 'dateRange'];
classicPropTypes.forEach(function (type) {
  PropTypes[type] = getShim();
});
var advancedPropTypes = ['spacing', 'typography'];
advancedPropTypes.forEach(function (type) {
  PropTypes[type] = getShim();
});
var functionalPropTypes = ['component', 'objectOf', 'arrayOf', 'oneOf', 'shape', 'embeddable'];
functionalPropTypes.forEach(function (type) {
  PropTypes[type] = getShim;
});
var defaults = {
  icon: {
    iconName: '',
    iconPrefix: '',
    defaultFilter: ''
  },
  image: {
    uriBase: '',
    imagePath: '',
    altText: '',
    width: 0,
    height: 0
  },
  slider: {
    min: 0,
    max: 10,
    stepSize: 1,
    selectedValue: 0
  }
};
var primitiveProp = function primitiveProp(type) {
  var checker = PropTypes[type];
  checker._meta = {
    type: type
  };
  checker.isRequired._meta = {
    type: type,
    isRequired: true
  };
  if (defaults[type]) {
    checker["default"] = defaults[type];
  }
  return checker;
};
var createTypeOfTypeChecker = function createTypeOfTypeChecker(type) {
  return function (arrType) {
    var appliedChecker = PropTypes[type](arrType);
    appliedChecker._meta = {
      type: type,
      argType: arrType._meta
    };
    appliedChecker.isRequired._meta = _objectSpread2(_objectSpread2({}, appliedChecker._meta), {}, {
      isRequired: true
    });
    return appliedChecker;
  };
};
var createEnumTypeChecker = function createEnumTypeChecker(expectedValues) {
  var appliedChecker = PropTypes.oneOf(expectedValues);
  appliedChecker._meta = {
    type: 'oneOf',
    values: expectedValues
  };
  appliedChecker.isRequired._meta = _objectSpread2(_objectSpread2({}, appliedChecker._meta), {}, {
    isRequired: true
  });
  return appliedChecker;
};
var createShapeTypeChecker = function createShapeTypeChecker(type) {
  return function (shapeObj) {
    var appliedChecker = PropTypes.shape(shapeObj);
    var objMeta = extractMetadata(shapeObj);
    appliedChecker._meta = {
      type: type,
      objMeta: objMeta
    };
    appliedChecker.isRequired._meta = _objectSpread2(_objectSpread2({}, appliedChecker._meta), {}, {
      isRequired: true
    });
    return appliedChecker;
  };
};
var componentTypeChecker = function componentTypeChecker(name) {
  var appliedChecker = PropTypes.shape({
    name: name
  });
  appliedChecker._meta = {
    type: 'component',
    allowedComponents: [name]
  };
  appliedChecker.isRequired._meta = _objectSpread2(_objectSpread2({}, appliedChecker._meta), {}, {
    isRequired: true
  });
  return appliedChecker;
};
var createComponentTypeChecker = function createComponentTypeChecker() {
  return componentTypeChecker;
};
var ElementPropTypes = {
  _version: '1.0.17-0',
  // classic types
  array: primitiveProp('array'),
  bool: primitiveProp('bool'),
  color: primitiveProp('color'),
  media: primitiveProp('media'),
  editorFull: primitiveProp('editorFull'),
  editorMinimal: primitiveProp('editorMinimal'),
  number: primitiveProp('number'),
  string: primitiveProp('string'),
  product: primitiveProp('product'),
  category: primitiveProp('category'),
  sectionHeader: primitiveProp('sectionHeader'),
  subHeader: primitiveProp('subHeader'),
  image: primitiveProp('image'),
  slider: primitiveProp('slider'),
  date: primitiveProp('date'),
  dateRange: primitiveProp('dateRange'),
  icon: primitiveProp('icon'),
  readOnly: primitiveProp('readOnly'),
  // functional types
  arrayOf: createTypeOfTypeChecker('arrayOf'),
  objectOf: createTypeOfTypeChecker('objectOf'),
  embeddable: createShapeTypeChecker('embeddable'),
  oneOf: createEnumTypeChecker,
  shape: createShapeTypeChecker('shape'),
  component: createComponentTypeChecker(),
  // advanced types
  typography: primitiveProp('typography'),
  spacing: primitiveProp('spacing')
};

export { ElementPropTypes, extractMetadata };
